module.exports = __webpack_public_path__ + "static/img/xsdcright.65b962e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/xsdcright.png
// module id = TuvV
// module chunks = 1